import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { reviewsService } from '../services/reviews.service'
import type { CreatePartReviewPayload, CreateDealReviewPayload } from '../types/review.types'

export const reviewKeys = {
  all: ['reviews'] as const,
  homepage: () => [...reviewKeys.all, 'homepage'] as const,
  myReviews: () => [...reviewKeys.all, 'my-reviews'] as const,
}

export function useHomepageReviews() {
  return useQuery({
    queryKey: reviewKeys.homepage(),
    queryFn: async () => {
      const res = await reviewsService.getHomepageReviews()
      return res.data ?? []
    },
    staleTime: 1000 * 60 * 5, // 5 mins cache
  })
}

export function useMyReviews() {
  return useQuery({
    queryKey: reviewKeys.myReviews(),
    queryFn: async () => {
      const res = await reviewsService.getMyReviews()
      return res.data ?? []
    },
  })
}

export function useSubmitPartReview() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreatePartReviewPayload) =>
      reviewsService.submitPartReview(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reviewKeys.myReviews() })
      queryClient.invalidateQueries({ queryKey: reviewKeys.homepage() })
    },
  })
}

export function useSubmitDealReview() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateDealReviewPayload) =>
      reviewsService.submitDealReview(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reviewKeys.myReviews() })
      queryClient.invalidateQueries({ queryKey: reviewKeys.homepage() })
      queryClient.invalidateQueries({ queryKey: ['chat'] })
    },
  })
}
